import type { PostLayoutType } from '../../../types';
import type { LinkMediaValue, MediaValue } from '../../data/sources';
import { usePreviewFetch } from '../../data/utils';
import { useSocialFeedSettings } from '../../utils';
import { usePost } from '../Post';
import { optimizeImagesSize } from './optimizeImagesSize';
import { usePostSettings } from './usePostSettings';

const fallbackCardLayoutRatio: Record<PostLayoutType, number> = {
  card1: 0.66,
  card2: 1,
  card3: 1,
  card4: 0.66,
  card5: 0.66
};

export const useMedia = (): MediaValue => {
  const { layout, postLayout } = useSocialFeedSettings();
  const { postImageRatio } = usePostSettings();
  const { rect, source, horizontal, url, media, repost } = usePost();
  const ratio = postImageRatio || fallbackCardLayoutRatio[postLayout];

  const isFacebookLink = source.type === 'facebook' && media?.type === 'link';

  const previewLink = isFacebookLink && !media.src ? url : undefined;
  const previewLinkData = usePreviewFetch(previewLink);

  if (repost) {
    const { media: repostMedia } = repost;

    return optimizeImagesSize(
      repostMedia,
      source.type,
      rect,
      ratio,
      layout,
      horizontal
    );
  }

  if (previewLinkData?.cover) {
    return { ...(media as LinkMediaValue), src: previewLinkData.cover };
  }

  return optimizeImagesSize(
    media,
    source.type,
    rect,
    ratio,
    layout,
    horizontal
  );
};
